(()=>{
  const init=root=>{
    if(!root||root.dataset.mmOrphanColoursReady)return;
    root.dataset.mmOrphanColoursReady='true';
    let variants=[];
    try{variants=JSON.parse(root.querySelector('[data-product-json]')?.textContent||'[]')}catch(e){return}
    const fieldsets=[...root.querySelectorAll('.variant-fieldset')];
    const colourFieldset=root.querySelector('.variant-fieldset--colour');
    if(!colourFieldset)return;
    const colourIndex=fieldsets.indexOf(colourFieldset);
    if(colourIndex<0)return;
    const hasMedia=v=>!!(v?.featured_media?.id||v?.featured_image?.id||v?.featured_image?.src||v?.featured_image);
    const visibleColours=new Set(variants.filter(hasMedia).map(v=>v?.options?.[colourIndex]).filter(Boolean));
    const labels=[...colourFieldset.querySelectorAll('.mmi-colour-swatch')];
    labels.forEach(label=>{
      const input=label.querySelector('input[type="radio"]');
      if(!input||visibleColours.has(input.value))return;
      label.hidden=true;
      label.style.display='none';
      input.disabled=true;
    });
    const checked=colourFieldset.querySelector('input[type="radio"]:checked:not(:disabled)');
    if(!checked){
      const first=colourFieldset.querySelector('input[type="radio"]:not(:disabled)');
      if(first){first.checked=true;first.dispatchEvent(new Event('change',{bubbles:true}))}
    }
    const remaining=labels.filter(l=>!l.hidden&&l.style.display!=='none');
    if(!remaining.length)colourFieldset.hidden=true;
  };
  const boot=()=>document.querySelectorAll('[data-product-root]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();